import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import ModalHeader from '@common-components/headers/ModalHeader';

const CancelAppModal = props => {

    const {
        modal:{
            modalData: {
                cb
            }
        },
        modalHeaderProps,
        actions: {
            hideModal
        }
    } = props;

    const handleCloseModal = () => hideModal();

    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader { ...{ ...modalHeaderProps }} />
            </div>
            <div className="grid-container">
                <div className="gi-modal__body">
                    <FormattedMessage id="modal.cancel_app_p1" tagName='p'/>
                    <FormattedMessage id="modal.cancel_app_p2" tagName='p'/>
                </div>
            </div>
            <div className="gi-modal__controls">
                <button onClick={handleCloseModal}
                    className="usa-button gi-button gi-button__outline">
                    <FormattedMessage id="modal.cancel_app_cta1"/>
                </button>
                <button onClick={cb}
                    className="usa-button gi-button gi-button__primary">
                    <FormattedMessage id="modal.cancel_app_cta2"/>
                </button>
            </div>
        </Fragment>
    );
};

export default CancelAppModal;
